export default {
    parts: ['badgeGroup', 'badge'],
    baseStyle: {
        badgeGroup: {
            flexWrap: 'wrap',
            gap: 1,
            alignContent: 'center'
        },
        badge: {
            whiteSpace: 'nowrap',
            borderRadius: 5,
            padding: 1,
            textStyle: 'Badge Regular',
            height: 'fit-content'
        }
    },
    variants: {
        permanent: {
            badge: {
                backgroundColor: 'stokkeCore.black',
                color: 'stokkeCore.white'
            }
        },
        nonPermanent: {
            badge: {
                backgroundColor: 'stokkeGray.mid',
                color: 'stokkeCore.black'
            }
        }
    }
}
